module.exports = __webpack_public_path__ + "img/convenio-de-practicas4.7e534c8e.png";